/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Access_Reason_UnavailableInputs */



/**
* | output |
* | --- |
* | "it is paused. Ask an admin of \"{name}\" to resume it." |
*
* @param {Agent_Access_Reason_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_reason_unavailable = /** @type {((inputs: Agent_Access_Reason_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Reason_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Pausiert. Bitten Sie einen Admin von „${i?.name}“, die Pause aufzuheben.`)
	return /** @type {LocalizedString} */ (`it is paused. Ask an admin of "${i?.name}" to resume it.`)
});